<template>
  <div class="componentAddPost">
    <b-form
      @submit.stop.prevent
      @submit="onSubmit"
      @reset="onReset"
      v-if="show"
      class="form"
    >
      <h2 class="mt-4 mb-3" v-if="edit">EDITAR POST</h2>
      <h2 class="mt-4 mb-3" v-else>ADICIONAR POST</h2>

      <b-form-group id="input-group-1" for="input-1">
        <b-form-input
          id="input-1"
          class="input"
          :state="validationInput"
          v-model="form.title"
          placeholder="Título"
        ></b-form-input>
        <b-form-valid-feedback :state="validationInput"> </b-form-valid-feedback>
        <b-form-invalid-feedback :state="validationInput">
          Digite o título.
        </b-form-invalid-feedback>
      </b-form-group>

      <b-form-group id="input-group-5" for="input-5">
        <b-form-input
          id="input-5"
          class="input"
          :state="validationInput5"
          v-model="form.author"
          placeholder="Autor"
        ></b-form-input>
        <b-form-valid-feedback :state="validationInput5"> </b-form-valid-feedback>
        <b-form-invalid-feedback :state="validationInput5">
          Digite o autor.
        </b-form-invalid-feedback>
      </b-form-group>

      <b-form-group id="input-group-2" for="input-2">
        <b-form-select
          id="input-2"
          class="input"
          :state="validationInput2"
          v-model="form.category"
          :options="categorys"
          placeholder="Categoria"
        ></b-form-select>

        <b-form-valid-feedback :state="validationInput2"> </b-form-valid-feedback>
        <b-form-invalid-feedback :state="validationInput2">
          Selecione a categoria.
        </b-form-invalid-feedback>
      </b-form-group>

      <b-form-group id="input-group-3" for="input-3">
        <vue-editor
          :editor-toolbar="customToolbar"
          id="input-3"
          class="input"
          v-model="texto"
          placeholder="Editor de texto"
          :class="{
            activeBorderError: isActiveBorderError,
            activeBorderTrue: isActiveBorderTrue,
          }"
        />
        <h6>{{ textError }}</h6>
      </b-form-group>

      <b-form-group id="input-group-4" label-for="input-4">
        <form>
          <label for="fileInput" class="custom-file-upload">
            <b-form-file
              id="fileInput"
              class="fileBootstrap"
              v-model="file"
              accept="image/*"
              :state="imageState"
              @input="crop()"
            ></b-form-file>
            {{ edit ? 'Editar imagem' : 'Upload de imagem' }}
          </label>
          <!--{{ verifyFile ? file.name : file }}-->
          <button
            v-if="imageMainModal"
            type="button"
            class="btn btn-light"
            @click="abrirModal()"
          >
            Ver imagem
          </button>
        </form>

        <b-form-valid-feedback :state="validationInput4"> </b-form-valid-feedback>

        <b-form-invalid-feedback :state="validationInput4">
          Insira uma imagem.
        </b-form-invalid-feedback>
      </b-form-group>

      <b-modal
        id="modal-show-image"
        ref="modal"
        centered
        no-close-on-esc
        no-close-on-backdrop
        hide-footer
      >
        <template #modal-header>
          <h5>Imagem Atual</h5>
        </template>
        <div class="image-container">
          <img
            class="image"
            width="250px"
            v-bind:src="imageMainModal"
            alt="Insira uma imagem."
          />
        </div>
        <b-row class="showButtonRow">
          <b-col>
            <button type="button" class="showButton buttonFooter" @click="fecharModal()">
              Fechar
            </button>
          </b-col>
        </b-row>
      </b-modal>
      <b-modal
        id="modal-prevent-cropper"
        ref="modal"
        centered
        no-close-on-esc
        no-close-on-backdrop
        hide-footer
      >
        <template #modal-header>
          <h5>Cortar Imagem</h5>
        </template>

        <cropper
          ref="cropper"
          class="cropper"
          :src="urlImage"
          :stencil-props="{
            aspectRatio: 1.55,
          }"
        />

        <b-row class="alignButton">
          <b-col>
            <b-button
              size="sm"
              @click="cancelCropper()"
              class="buttonFooter cancelcrop mt-4 "
            >
              Cancelar
            </b-button>
            <b-button
              size="sm"
              @click="okCropper()"
              class="buttonFooter savecrop mt-4 ml-2"
            >
              Salvar
            </b-button>
          </b-col>
        </b-row>
      </b-modal>
      <b-row class="buttonalign">
        <b-col>
          <b-button class="cancel buttonBlog " @click="Cancel(true)" v-b-modal.cancelar
            >Cancelar</b-button
          >
          <b-button class="save buttonBlog" v-b-modal.editar v-if="edit">Editar</b-button>
          <b-button type="submit" class="save buttonBlog" v-else>Salvar</b-button>
        </b-col>
      </b-row>
    </b-form>

    <PopupConfirmacao
      id_modal="cancelar"
      cor_imagem="#E2574C"
      titulo="Atenção"
      texto="As alterações não serão salvas, deseja continuar?"
      texto_botao1="Continuar"
      cor_botao1="#FFFFFF"
      cor_background_botao1="#EB5353"
      hover_botao1="#a53a36"
      texto_botao2="Cancelar"
      cor_botao2="#FFFFFF"
      cor_background_botao2="#ADADAD"
      hover_botao2="#8b8b8b"
      :confirma_acao="onReset"
    />

    <PopupConfirmacao
      id_modal="editar"
      cor_imagem="#E2574C"
      titulo="Atenção"
      texto="Deseja editar o post?"
      texto_botao1="Continuar"
      cor_botao1="#FFFFFF"
      cor_background_botao1="#28a745"
      hover_botao1="#28a745"
      texto_botao2="Cancelar"
      cor_botao2="#FFFFFF"
      cor_background_botao2="#ADADAD"
      hover_botao2="#8b8b8b"
      :confirma_acao="onSubmit"
    />
  </div>
</template>
<style lang="scss">
.componentAddPost {
  .btn {
    border: 1px solid #ccc;
    background: #fff;
    border-radius: 5px;
    color: #373a3c;
    padding: 8.5px 20px 8.5px 20px;
    margin-bottom: 0.3rem;
    margin-left: 1rem;
  }
  .btn:hover {
    background: #ccc;
    transition: 0.3s;
  }
  .btn-light:focus {
    border: 1px solid #ccc;
    background: #fff;
    border-radius: 5px;
    color: #373a3c;
    box-shadow: none;
  }
}
</style>
<style lang="scss" scoped>
.cropper {
  height: 25rem;
  background: #ddd;
  max-width: 765px;
  max-height: 474px;
  align-self: start;
}
.image-container {
  display: flex;
  justify-content: center;
  width: 100%;
}
.image {
  width: 310px;
  height: 200px;
}
.showButton {
  background-color: #343842;
  border: #343842;
  color: #ffffff;
}
.showButtonRow {
  float: right;
  margin-right: 1rem;
  margin-top: 0.5rem;
}
.alignButton {
  float: right;
}
.buttonFooter {
  width: 7rem;
  height: 2.3rem;
  border-radius: 0.15rem;
  padding: 0;
  margin: 0.2rem;
  font-family: 'Noto Sans', sans-serif;
  font-size: 0.9rem;
}
.cancelcrop {
  background-color: #cccccc;
  border: #cccccc;
  color: #ffffff;
}
.cancelcrop:hover {
  background-color: #f04848;
  border: #f04848;
  color: #e9e9e9;
}
.savecrop {
  background-color: #343842;
  border: #343842;
  color: #ffffff;
}
.savecrop:hover {
  background-color: #343842;
}
.componentAddPost {
  h2 {
    font-family: 'Noto Sans', sans-serif;
    font-weight: 600;
  }
  #input-3 {
    height: 14rem;
    background-color: #fff;
  }
  #input-group-3 h6 {
    color: #dc3545;
    font-size: 12.8px;
  }

  .buttonalign {
    text-align: right;
    margin-right: 3rem;
  }

  .input {
    width: 50rem;
  }

  .form {
    margin-left: 5rem;
  }
  .buttonBlog {
    width: 6.7rem;
    height: 2rem;
    border-radius: 0.15rem;
    padding: 0;
    margin: 0.2rem;
    font-family: 'Noto Sans', sans-serif;
    font-size: 0.9rem;
  }

  .cancel {
    background-color: #cccccc;
    border: #cccccc;
    color: #ffffff;
  }
  .cancel:hover {
    background-color: #f04848;
    border: #f04848;
    color: #e9e9e9;
  }
  .save {
    background-color: #343842;
    border: #343842;
    color: #ffffff;
  }
  .save:hover {
    background-color: #343842;
  }
  .verifyText {
    border-color: magenta !important;
  }
  .input::placeholder {
    font-size: 1rem;
    color: #495057;
  }
  .ql-blank::before {
    font-size: 1rem !important;
    color: #495057 !important;
    font-style: normal !important;
  }

  .activeBorderError {
    border: 0.1rem solid #dc3545;
  }
  .activeBorderTrue {
    border: 0.1rem solid #28a745;
  }
  .fileBootstrap {
    display: none;
  }
  .custom-file-upload {
    border: 1px solid #ccc;
    padding: 8px 20px 8px 20px;
    background: #fff;
    border-radius: 5px;
    color: #373a3c;
    font-weight: 400;
    cursor: pointer;
  }
  .custom-file-upload:hover {
    background: #ccc;
    transition: 0.3s;
  }

  @media (max-width: 768px) {
    .form {
      margin-left: 5rem !important;
    }
    .buttonalign {
      margin-right: 0rem;
    }
    #input-3 {
      height: 12rem;
    }
  }

  @media (max-width: 1024px) {
    .input {
      width: 95% !important ;
    }
  }
  @media (max-width: 320px) {
    h2 {
      font-size: 1.5rem;
    }
    #input-3 {
      height: 7rem;
    }
    .buttonBlog {
      width: 6rem;
    }
  }
  @media (max-width: 540px) and (min-width: 540px) {
    .form {
      margin-left: 8rem !important;
    }
  }
  @media (max-width: 768px) and (min-width: 768px) {
    .form {
      margin-left: -5rem !important;
    }
    .input {
      width: 32rem !important;
    }
  }
  @media (max-width: 1024px) and (min-width: 1024px) {
    .form {
      margin-left: -5rem !important;
    }
    .input {
      width: 45rem !important;
    }
  }
  @media (min-width: 2560px) {
    h2 {
      font-size: 3rem;
    }
    #input-3 {
      height: 25rem;
    }
    .input {
      width: 70rem;
    }
    .form {
      margin-left: 10rem;
      margin-top: 5rem;
    }
    .save {
      margin-right: 59.5rem;
    }
  }
}
</style>

<!-- Props: edit: se for true vira editar post, se for false vira adicionar post-->

<script>
import { VueEditor } from 'vue2-editor';
import { Cropper } from 'vue-advanced-cropper';
import 'vue-advanced-cropper/dist/style.css';
import backUrl from '../../utils/backUrl';
import PopupConfirmacao from '@/components/dashboard/PopupConfirmacao.vue';
import { postArticle, getArticleIndividual, putArticle } from '@/services/api/Article';
import { getCategory } from '@/services/api/Category';

import { seo } from '@/utils/seo.js';

export default {
  name: 'addPost',
  components: { PopupConfirmacao, Cropper },
  VueEditor,
  props: {
    edit: {
      type: Boolean,
      default: false,
    },
  },
  metaInfo() {
    return seo(
      'Adicionar Post',
      'Adicionar artigo para o Blog - Site do Projeto Niara',
      `${this.backUrl}/download-file/logo/ProjetoNiaraLogo.png`,
      this.thisUrl,
      'website',
      ' - Dashboard Projeto Niara',
    );
  },
  data() {
    return {
      thisUrl: window.location.href,
      backUrl: backUrl,
      texto: '',
      file: null,

      textError: '',
      isActiveBorderError: false,
      isActiveBorderTrue: false,
      send: false,

      verifyFile: false,
      imagemAntiga: false,

      urlImage: '',
      nameImage: '',
      imageState: null,
      nameState: null,

      slug: this.$route.params.slug,

      form: {
        id: '',
        title: '',
        author: '',

        category: null,
      },
      imageMainModal: null,
      categorys: [],
      customToolbar: [
        ['bold', 'italic', 'underline'],
        [{ list: 'bullet' }, { list: 'ordered' }],
        [{ header: 1 }, { header: 2 }],
        [{ align: '' }, { align: 'center' }, { align: 'right' }, { align: 'justify' }],
        [{ size: ['small', false, 'large', 'huge'] }],
      ],
      show: true,
    };
  },
  methods: {
    abrirModal() {
      this.$bvModal.show('modal-show-image');
    },
    fecharModal() {
      this.$bvModal.hide('modal-show-image');
    },
    verifyInput3() {
      if (this.send) {
        if (this.texto == '') {
          this.textError = 'Digite o texto.';
          this.isActiveBorderError = true;
          this.isActiveBorderTrue = false;
        } else {
          this.textError = '';
          this.isActiveBorderError = false;
          this.isActiveBorderTrue = true;
        }
      } else {
        this.textError = '';
        this.isActiveBorderError = false;
        this.isActiveBorderTrue = false;
      }
    },

    verifyInputs() {
      this.verifyInput3();

      if (
        (this.form.title != '') &
        (this.form.author != '') &
        (this.texto != '') &
        (this.form.category != null) &
        (this.file != null)
      ) {
        return true;
      }
      return false;
    },
    onSubmit(event) {
      this.send = true;
      if (this.edit) this.$root.$emit('bv::hide::modal', 'editar');
      if (this.verifyInputs()) {
        let data = new FormData();

        data.append('category', this.form.category);
        data.append('author', this.form.author);
        data.append('title', this.form.title);
        data.append('text', this.texto);
        if (this.edit) {
          data.append('image', this.file);
          putArticle(data, this.form.id)
            .then(() => {
              this.send = false;
              this.verifyInput3();

              this.$router.push({ name: 'Blog' });
            })
            .catch(() => {
              this.$bvToast.toast(
                'Erro ao editar postagem, recarregue a página e tente novamente. Caso persista, tente novamente mais tarde.',
                {
                  title: 'Erro ao editar postagem',
                  autoHideDelay: 5000, //Tempo em milissegundos para o toast desaparecer
                  variant: 'danger', //Danger é a variante vermelha. Variantes: default, primary, secondary, danger,warning, success e info
                },
              );
              this.send = false;
              this.verifyInput3();
              this.$bvToast.toast(
                'Erro interno no servidor, recarregue a página. Caso persista, tente novamente mais tarde.',
                {
                  title: 'Erro interno no servidor',
                  autoHideDelay: 5000, //Tempo em milissegundos para o toast desaparecer
                  variant: 'danger', //Danger é a variante vermelha. Variantes: default, primary, secondary, danger,warning, success e info
                },
              );
            });
        } else {
          data.append('image', this.file);
          postArticle(data)
            .then(() => {
              this.send = false;
              this.verifyInput3();

              this.$router.push({ name: 'Blog' });
            })
            .catch(() => {
              this.$bvToast.toast(
                'Erro ao adicinar postagem, recarregue a página e tente novamente. Caso persista, tente novamente mais tarde.',
                {
                  title: 'Erro ao adicionar postagem',
                  autoHideDelay: 5000, //Tempo em milissegundos para o toast desaparecer
                  variant: 'danger', //Danger é a variante vermelha. Variantes: default, primary, secondary, danger,warning, success e info
                },
              );
              this.send = false;
              this.verifyInput3();
              this.$bvToast.toast(
                'Erro interno no servidor, recarregue a página. Caso persista, tente novamente mais tarde.',
                {
                  title: 'Erro interno no servidor',
                  autoHideDelay: 5000, //Tempo em milissegundos para o toast desaparecer
                  variant: 'danger', //Danger é a variante vermelha. Variantes: default, primary, secondary, danger,warning, success e info
                },
              );
            });
        }
      }
      event.preventDefault();
    },

    onReset(event) {
      event.preventDefault();
      // Reset our form values
      this.send = false;
      this.textError = '';
      this.isActiveBorderError = false;
      this.isActiveBorderTrue = false;
      this.form.title = '';
      this.texto = '';
      this.form.category = null;
      this.file = null;
      this.imageMainModal = null;
      // Trick to reset/clear native browser form validation state
      this.show = false;
      this.$router.push({ name: 'Blog' });
      this.$nextTick(() => {
        this.show = true;
      });
    },

    onChange(event) {
      this.file = event.target.files[0];
    },
    crop() {
      if (this.file != null) {
        const readImage = () => {
          if (this.file) {
            var file = new FileReader();
            file.onload = (e) => {
              this.urlImage = e.target.result;
            };
            file.readAsDataURL(this.file);
          }
        };
        readImage();
        this.$root.$emit('bv::show::modal', 'modal-prevent-cropper');
      }
    },
    okCropper() {
      this.nameImage = this.file.name;
      this.$root.$emit('bv::hide::modal', 'modal-prevent-cropper');
      this.file = this.$refs.cropper.getResult().canvas;
      this.imageMainModal = this.$refs.cropper.getResult().canvas.toDataURL();
      this.file.toBlob(
        (blob) => {
          this.file = blob;

          this.$root.$emit('bv::show::modal', this.idModal);
          this.file = new File([this.file], 'img.jpeg', {
            lastModified: new Date().getTime(),
            type: this.file.type,
          });
        },
        'image/jpeg',
        0.75,
      );
    },
    cancelCropper() {
      this.$root.$emit('bv::hide::modal', 'modal-prevent-cropper');
    },
  },
  watch: {
    texto: function() {
      if (this.send) this.verifyInput3();
    },
    file: function() {
      if (this.edit) {
        if (this.imagemAntiga == this.file) {
          this.verifyFile = false;
        } else {
          this.verifyFile = true;
        }
      } else {
        this.verifyFile = true;
      }
    },
  },
  computed: {
    validationInput() {
      // if (input == 1) {
      if (!this.send) {
        return null;
      } else {
        return this.form.title.length > 0;
      }
    },
    validationInput2() {
      if (!this.send) {
        return null;
      } else {
        return this.form.category != null;
      }
    },
    validationInput4() {
      if (!this.send) {
        return null;
      } else {
        return this.file != null;
      }
    },

    validationInput5() {
      if (!this.send) {
        return null;
      } else {
        return this.form.author.length > 0;
      }
    },
  },
  mounted() {
    getCategory()
      .then((res) => {
        this.categorys = res.data.map((item) => {
          return { text: item.name, value: item.id };
        });
        this.categorys = [{ text: 'Categoria', value: null }, ...this.categorys];
      })
      .catch(() => {
        this.$bvToast.toast(
          'Erro interno no servidor, recarregue a página. Caso persista, tente novamente mais tarde.',
          {
            title: 'Erro interno no servidor',
            autoHideDelay: 5000, //Tempo em milissegundos para o toast desaparecer
            variant: 'danger', //Danger é a variante vermelha. Variantes: default, primary, secondary, danger,warning, success e info
          },
        );
      });
    if (this.edit) {
      getArticleIndividual(this.slug)
        .then((res) => {
          this.form.title = res.data.title;
          this.form.author = res.data.author;
          this.texto = res.data.text;
          this.form.category = res.data.category;
          this.file = res.data.image;
          this.imagemAntiga = res.data.image;
          this.form.id = res.data._id;
          this.imageMainModal = `${backUrl}/download-file/images/${res.data.image}`;
        })
        .catch(() => {
          this.$bvToast.toast(
            'Erro interno no servidor, recarregue a página. Caso persista, tente novamente mais tarde.',
            {
              title: 'Erro interno no servidor',
              autoHideDelay: 5000, //Tempo em milissegundos para o toast desaparecer
              variant: 'danger', //Danger é a variante vermelha. Variantes: default, primary, secondary, danger,warning, success e info
            },
          );
        });
    }
  },
};
</script>
